import { render, staticRenderFns } from "./MenuSettings.vue?vue&type=template&id=6d2cb87c&scoped=true&"
import script from "./MenuSettings.vue?vue&type=script&lang=js&"
export * from "./MenuSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2cb87c",
  null
  
)

export default component.exports